"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20.25 12a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0m-3.975 2.545-.916-1.196a.96.96 0 0 0-1.346-.181l-.599.457c-.188.143-.483.019-.697-.111-.359-.216-.773-.617-1.165-1.128-.746-.975-1.045-1.868-.711-2.123l.001-.001.598-.454a.96.96 0 0 0 .18-1.343l-.916-1.197a.963.963 0 0 0-1.346-.179l-1.153.88c-1.254.958-.743 3.238 1.333 5.952 1.58 2.064 3.155 3.19 4.371 3.19.383 0 .73-.112 1.031-.341l1.153-.88c.204-.154.334-.38.369-.634s-.032-.506-.187-.709z"
}), 'TelephoneCircleFilled');
//# sourceMappingURL=index.js.map